<template>
    <div class="map-container">
        <div class="map-interactions">
            <div v-show="$store.state.view === 'search'">
                <div class="search-container tw-relative">
                    <div class="input-group">
                        <input type="text"
                            placeholder=" "
                            v-model="$store.state.userAddress"
                            ref="searchBox"
                        >
                        <label v-if="!$store.state.userAddress">
                            Indiquez vos coordonnées, adresse…
                        </label>
                        <button type="button" class="btn-search" @click="searchForPlace">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16.834" height="16.834" viewBox="0 0 16.834 16.834"><g id="Icon_feather-search" data-name="Icon feather-search" transform="translate(1 1)"><path id="Path_528" data-name="Path 528" d="M17.318,10.909A6.409,6.409,0,1,1,10.909,4.5a6.409,6.409,0,0,1,6.409,6.409Z" transform="translate(-4.5 -4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/><path id="Path_529" data-name="Path 529" d="M28.46,28.46l-3.485-3.485" transform="translate(-14.04 -14.04)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></g></svg>
                        </button>
                    </div>
                    <button type="button" class="btn-cta btn-cta-white" @click="getCurrentPosition" v-if="!$store.state.userPosition">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><path id="Icon_ionic-md-locate" data-name="Icon ionic-md-locate" d="M13.25,9.321a3.929,3.929,0,1,0,3.929,3.929A3.94,3.94,0,0,0,13.25,9.321ZM22.626,12.2A9.464,9.464,0,0,0,14.3,3.874V2.25H12.2V3.874A9.464,9.464,0,0,0,3.874,12.2H2.25v2.1H3.874A9.465,9.465,0,0,0,12.2,22.626V24.25h2.1V22.626A9.465,9.465,0,0,0,22.626,14.3H24.25V12.2ZM13.25,20.583a7.333,7.333,0,1,1,7.333-7.333A7.355,7.355,0,0,1,13.25,20.583Z" transform="translate(-2.25 -2.25)" fill="#ec1c24"/></svg>
                        Utiliser ma position actuelle
                    </button>
                </div>
                <div class="store-list" v-if="$store.state.userPosition">
                    <transition-group tag="div" name="store-list" v-if="visibleStores.length">
                        <div class="store-single" v-for="store in visibleStores" :key="store.name">
                            <h3>
                                {{ store.name }}
                            </h3>
                            <p>
                                {{ store.address }}
                                <br>
                                {{ store.zip_code }}
                            </p>
                            <h4 v-if="$store.state.userAddress">
                                {{ store.distance }} |
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><path id="Icon_metro-phone" data-name="Icon metro-phone" d="M12.1,11.656c-.867.867-.867,1.733-1.733,1.733s-1.733-.867-2.6-1.733-1.733-1.733-1.733-2.6S6.9,8.189,7.771,7.323s-1.733-3.467-2.6-3.467-2.6,2.6-2.6,2.6c0,1.733,1.781,5.247,3.467,6.933s5.2,3.467,6.933,3.467c0,0,2.6-1.733,2.6-2.6s-2.6-3.467-3.467-2.6Z" transform="translate(-2.571 -3.856)" fill="#ec1c24"/></svg>
                                <small>{{ store.phone }}</small>
                            </h4>
                            <h4 v-else>
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><path id="Icon_metro-phone" data-name="Icon metro-phone" d="M12.1,11.656c-.867.867-.867,1.733-1.733,1.733s-1.733-.867-2.6-1.733-1.733-1.733-1.733-2.6S6.9,8.189,7.771,7.323s-1.733-3.467-2.6-3.467-2.6,2.6-2.6,2.6c0,1.733,1.781,5.247,3.467,6.933s5.2,3.467,6.933,3.467c0,0,2.6-1.733,2.6-2.6s-2.6-3.467-3.467-2.6Z" transform="translate(-2.571 -3.856)" fill="#ec1c24"/></svg>
                                <small>{{ store.phone }}</small>
                            </h4>
                            <div class="tw-grid tw-grid-cols-2 tw-gap-4 tw-mt-6">
                                <a class="btn-cta btn-cta-goto" :href="store.link" target="_blank">
                                    Je commande
                                </a>
                                <button class="btn-cta btn-cta-search" @click="iteneraryHandler(store)">
                                    Itinéraire
                                </button>
                            </div>
                        </div>
                    </transition-group>
                    <div class="store-single" v-else>
                        <h3>Désolé, mais il n'y a pas de magasins près de chez vous. Veuillez consulter notre magasin en ligne <u><a href="https://www.rougier-ple.fr/">ici</a></u>.</h3>
                    </div>
                </div>
            </div>
            <div v-if="$store.state.view === 'info' && $store.state.map">
                <StoreInfo />
            </div>
        </div>
        <div id="map" :class="{'active' : $store.state.userPosition}">
            <div class="loader"></div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import StoreInfo from '@/components/StoreInfo.vue';
import locationIcon from '@/assets/img/icons/location.svg';
import markerIcon from '@/assets/img/icons/marker.png';

export default {
    name: 'map-container',
    components: {
        StoreInfo,
    },
    data() {
        return {
            visibleStores: [],
            userMarker: undefined,
            infowindow: undefined,
            mobileView: 'map',
        };
    },
    computed: {
        ...mapState({
            stores: (state) => state.stores,
        }),
    },
    methods: {
        getCurrentPosition() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    this.$store.state.userPosition = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                    this.userMarker = new this.$store.state.google.maps.Marker({
                        clickable: false,
                        map: this.$store.state.map,
                        origin: new this.$store.state.google.maps.Point(0, 0),
                        zIndex: 999,
                        icon: locationIcon,
                        position: this.$store.state.userPosition,
                    });
                    this.$store.state.map.setCenter(this.$store.state.userPosition);
                    this.$store.state.map.setZoom(this.$store.state.zoomLevel);
                    geocoder.geocode({
                        location: this.$store.state.userPosition,
                    }, (results, status) => {
                        this.$store.state.userAddress = status === google.maps.GeocoderStatus.OK ? results[0].formatted_address : 'Address unavailable';
                    });
                },
                () => {
                    this.userMarker = new this.$store.state.google.maps.Marker({
                        clickable: false,
                        map: this.$store.state.map,
                        origin: new this.$store.state.google.maps.Point(0, 0),
                        zIndex: 999,
                        icon: locationIcon,
                        position: this.$store.state.fallbackPosition,
                    });
                    this.$store.state.map.setCenter(this.$store.state.fallbackPosition);
                    this.$store.state.map.setZoom(this.$store.state.zoomLevel);
                });
            } else {
                this.userMarker = new this.$store.state.google.maps.Marker({
                    clickable: false,
                    map: this.$store.state.map,
                    origin: new this.$store.state.google.maps.Point(0, 0),
                    zIndex: 999,
                    icon: locationIcon,
                    position: this.$store.state.fallbackPosition,
                });
                this.$store.state.map.setCenter(this.$store.state.fallbackPosition);
                this.$store.state.map.setZoom(this.$store.state.zoomLevel);
            }
        },
        searchForPlace() {
            geocoder.geocode({
                address: this.$store.state.userAddress,
            }, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK) {
                    this.$store.state.userPosition = results[0].geometry.location;
                    this.$store.state.map.setCenter(results[0].geometry.location);
                    this.$store.state.map.setZoom(this.$store.state.zoomLevel);
                } else {
                    this.$store.state.map.setCenter(this.$store.state.fallbackPosition);
                }
            });
        },
        getVisibleStores() {
            const bounds = this.$store.state.map.getBounds();
            const currentlyVisibleStores = [];

            this.stores.forEach((store) => {
                if (bounds.contains(store.location) && this.$store.state.userPosition) {
                    currentlyVisibleStores.push(store);
                }
            });
            if (JSON.stringify(this.visibleStores) !== JSON.stringify(currentlyVisibleStores)) {
                this.visibleStores = [];
                currentlyVisibleStores.forEach((store) => {
                    this.visibleStores.push(store);
                    this.getDistanceToLocation(store.location, (response) => { store.distance = response; });
                });
            }
        },
        getDistanceToLocation(storePosition, fn) {
            if (this.$store.state.view === 'search') {
                const directionsService = new this.$store.state.google.maps.DirectionsService();
                const request = {
                    origin: this.$store.state.userPosition,
                    destination: storePosition,
                    travelMode: this.$store.state.google.maps.DirectionsTravelMode.DRIVING,
                };
                directionsService.route(request, (response, status) => {
                    if (status === this.$store.state.google.maps.DirectionsStatus.OK) {
                        return fn(response.routes[0].legs[0].distance.text);
                    }
                    return fn('no distance available');
                });
            }
        },
        iteneraryHandler(store) {
            if (this.$store.state.userAddress) {
                this.$store.state.view = 'info';
                this.$store.state.selectedStore = store;
                return;
            }
            this.$refs.searchBox.focus();
        },
    },
    mounted() {
        this.$store.dispatch('loadStores');
        this.$store.state.map = new this.$store.state.google.maps.Map(document.getElementById('map'), {
            center: this.$store.state.fallbackPosition,
            zoom: 6,
            mapTypeControl: false,
            scaleControl: false,
            fullscreenControl: false,
            streetViewControl: false,
            zoomControl: false,
            styles: [
                {
                    featureType: 'poi',
                    stylers: [
                        { visibility: 'off' },
                    ],
                },
            ],
        });

        window.geocoder = new this.$store.state.google.maps.Geocoder();

        const searchBox = new this.$store.state.google.maps.places.Autocomplete(this.$refs.searchBox);
        searchBox.setComponentRestrictions({
            country: ['fr'],
        });

        this.$store.state.google.maps.event.addListener(searchBox, 'place_changed', () => {
            const place = searchBox.getPlace();

            if (!place.geometry) {
                const firstOption = document.querySelector('.pac-container .pac-item').innerHTML;

                const geocoder = new google.maps.Geocoder();
                geocoder.geocode({ address: firstOption }, (geoPlace, status) => {
                    if (status === google.maps.GeocoderStatus.OK) {
                        const lat = geoPlace[0].geometry.location.lat();
                        const lng = geoPlace[0].geometry.location.lng();
                        this.$store.state.userAddress = geoPlace[0].address_components[0].long_name;
                        this.$store.state.userPosition = new google.maps.LatLng(lat, lng);

                        this.userMarker = this.userMarker ? this.userMarker.setMap(null) : false;
                        this.userMarker = new this.$store.state.google.maps.Marker({
                            clickable: false,
                            map: this.$store.state.map,
                            origin: new this.$store.state.google.maps.Point(0, 0),
                            zIndex: 999,
                            icon: locationIcon,
                            position: this.$store.state.userPosition,
                        });
                        this.$store.state.map.setCenter(geoPlace[0].geometry.location);
                        this.$store.state.map.setZoom(this.$store.state.zoomLevel);
                    }
                });
            } else {
                this.$store.state.userAddress = place.formatted_address;
                this.$store.state.userPosition = place.geometry.location;
                this.userMarker = this.userMarker ? this.userMarker.setMap(null) : false;
                this.userMarker = new this.$store.state.google.maps.Marker({
                    clickable: false,
                    map: this.$store.state.map,
                    origin: new this.$store.state.google.maps.Point(0, 0),
                    zIndex: 999,
                    icon: locationIcon,
                    position: this.$store.state.userPosition,
                });
                this.$store.state.map.setCenter(place.geometry.location);
                this.$store.state.map.setZoom(this.$store.state.zoomLevel);
            }
        });

        setTimeout(() => {
            this.stores.forEach((store) => {
                this.infowindow = new this.$store.state.google.maps.InfoWindow({
                    content: store.name,
                });
                const marker = new this.$store.state.google.maps.Marker({
                    map: this.$store.state.map,
                    origin: new this.$store.state.google.maps.Point(0, 0),
                    icon: markerIcon,
                    position: store.location,
                    title: store.name,
                });
                marker.addListener('click', (e) => {
                    if (!this.$store.state.userPosition) {
                        this.$store.state.userPosition = e.latLng;
                    }
                    this.$store.state.map.setCenter(e.latLng);
                    this.$store.state.map.setZoom(17);
                    this.infowindow.open(map, marker);
                });
            });
        }, 100);
        this.$store.state.map.addListener('idle', () => {
            this.getVisibleStores();
        });
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';

.map-container {
    position: relative;
    width: 100%;
    height: 100%;
}
#map {
    align-self: stretch;
    height: 500px;

    @screen lg {
        height: 100%;
    }

    &.active {
        @screen lg {
            margin-left: 375px;
        }
    }
    .loader {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 1;
        margin-top: -50px;
        margin-left: -50px;
        width: 100px;
        height: 100px;
        border: 18px solid #f3f3f3;
        border-top: 18px solid $main_color;
        border-radius: 100%;
        animation: spin 2s linear infinite;
    }
}
.map-interactions {
    background-color: $light_gray;

    @screen lg {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        overflow: hidden;
        max-width: 375px;
        max-height: 100%;
        width: 100%;
        height: auto;
        box-shadow: 0 0 6px transparentize(#000, .9);
    }
    .search-container {
        padding: 20px;
        background-color: $light_gray;
    }
    .store-list {
        z-index: 10;
        overflow: auto;
        max-height: 300px;
        width: 100%;
        height: auto;
        background-color: #fff;

        @screen lg {
            max-height: 100%;
            height: 630px;
        }
        .store-single {
            position: relative;
            padding: 30px 30px 30px 60px;
            border-bottom: 1px solid $light_gray;
            background-color: #fff;
            font-family: 'Helvetica';

            &:before {
                position: absolute;
                top: 30px;
                bottom: 0;
                left: 20px;
                width: 25px;
                background-image: url(~@/assets/img/icons/marker.svg);
                background-position: 0 -5px;
                background-size: contain;
                background-repeat: no-repeat;
                content: '';
            }

            h3 {
                margin-bottom: 15px;
                font-weight: 700;
                font-size: 16px;
            }
            p {
                margin-bottom: 12px;
                color: $text_gray;
                font-size: 13px;
                line-height: 16px;
            }
            h4 {
                display: flex;
                align-items: center;
                font-weight: 700;
                font-size: 14px;

                svg {
                    margin: 0 5px;
                    width: 13px;
                }
            }
        }
    }
}

</style>
